import styled, { css } from 'styled-components'
import { transparentize } from 'polished'

const mixin = {
  position: css`
    position: ${props => {
      if (props.relative) return 'relative'
      if (props.absolute) return 'absolute'
    }};
  `,
  textAlign: css`
    text-align: ${props => {
      if (props.taCenter) return 'center'
      if (props.taLeft) return 'left'
      if (props.taRight) return 'right'
      return 'inherit'
    }};
  `
}

export const Absolute = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`

export const Relative = styled.div`
  position: relative;
  z-index: 0;
`

export const Section = styled.section`
  ${mixin.position}
  width: 100%;
  padding: ${props => {
    if (props.thick) return '10rem 0'
    if (props.thin) return '2.5rem 0'
    return '5rem 0'
  }};
  background-color: ${props => {
    if (props.dark) return transparentize(0.15, 'black')
    return 'transparent'
  }};
  color: ${props => {
    if (props.dark) return 'white'
    return 'inherit'
  }};
`

export const Container = styled.div`
  ${mixin.position}
  ${mixin.textAlign}
  margin: 0 auto;
  width: 90vw;
  max-width: ${props => {
    if (props.skinny) return '888px'
    if (props.skinnier) return '555px'
    return '1111px'
  }};
  position: ${props => props.relative ? 'relative' : 'static'};
`

export const Flex = styled.div`
  display: flex;
  flex-direction: ${props => props.column ? 'column' : 'row'};
  justify-content: ${props => {
    if (props.justifyCenter) return 'center'
    if (props.justifyEnd) return 'flex-end'
    if (props.justifyBetween) return 'space-between'
    if (props.justifyAround) return 'space-around'
    return 'flex-start'
  }};
  align-items: ${props => {
    if (props.alignStart) return 'flex-start'
    if (props.alignEnd) return 'flex-end'
    if (props.alignStretch) return 'stretch'
    return 'center'
  }};
  height: ${props => props.fill ? '100%' : 'auto'};
  width: ${props => props.fill ? '100%' : 'auto'};
`

export const Content = styled.div`
  img, object, iframe {
    max-width: 100%;
    margin: 2.5rem auto;
    display: block;
  }
`

export const BackgroundImage = styled(Absolute)`
  background-size: cover;
  background-position: center;
  background-image: url(${props => props.image});
  opacity: ${props => props.opacity || 1};
  transition: opacity .5s ease;
`



// WEBPACK FOOTER //
// ./src/components/common.js